import styled from 'styled-components'

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  min-width: 0;
  font-family: Helvetica, Roboto, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', sans-serif;
  font-size: 15px;
  line-height: 18px;
  text-transform: uppercase;
  font-weight: 200;
  color: #808080;
  font-weight: 400;
  font-size: 13px !important;
  line-height: 19.9px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 0;
`

export const Switch = styled.div`
  position: relative;
  width: 40px;
  height: 18px;
  background: #808080;
  border-radius: 32px;
  padding: 4px;
  transition: 300ms all;

  &:before {
    transition: 300ms all;
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 35px;
    top: 50%;
    left: 2px;
    background: white;
    transform: translate(0, -50%);
  }
`

export const Input = styled.input`
  opacity: 0;
  position: absolute;

  &:checked + ${Switch} {
    background: #282828;

    &:before {
      transform: translate(20px, -50%);
    }
  }
`
